import {
  ITransactionSetTypes,
  ITransactionSetSubtypes,
  ITransactionSetWithSubtype,
} from 'types/graphqlTypes'

/**
 * create a single string from a transaction set + subtype
 * intended to be used as a select option value
 *
 * any change to this function needs an accompanying change in decodeOptionValue below
 *
 * @example encodeOptionValue(transactionSet, transactionSetSubtype) // 'setName::setType'
 */
export const encodeOptionValue = (
  transactionSet: ITransactionSetTypes | unknown,
  transactionSetSubtype?: ITransactionSetSubtypes | unknown
): string => {
  return `${transactionSet || ''}::${transactionSetSubtype || ''}`
}

/**
 * decode a string created by encodeOptionValue back into separate transaction set + subtype
 *
 * any change to this function needs an accompanying change in encodeOptionValue above
 *
 * @example decodeOptionValue('_214::SCHEDULED_TRACKING') // {transactionSet: '_214', transactionSetSubtype: 'SCHEDULED_TRACKING'}
 */
export const decodeOptionValue = (encoded: string): ITransactionSetWithSubtype => {
  const parts = encoded.split('::')

  const output: ITransactionSetWithSubtype = {
    transactionSet: (<any>ITransactionSetTypes)[parts[0]],
  }

  if (parts[1]) {
    output.transactionSetSubtype = (<any>ITransactionSetSubtypes)[parts[1]]
  }

  return output
}
